import { useState, useEffect } from "react";
import { Modal, Button, Form, Alert, Spinner } from "react-bootstrap";
import { useAuth } from "react-oidc-context";

const EMAIL_SENT_MESSAGE =
  "An email with the verification link has been sent to the supplied email address. New email will be saved once link is used and email is verified";

function UserProfileModal({ show, onHide, onSave, onEmailSaved }) {
  const auth = useAuth();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [initialValues, setInitialValues] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const isDirty =
    firstName !== initialValues.firstName ||
    lastName !== initialValues.lastName ||
    email !== initialValues.email ||
    phone !== initialValues.phone;

  useEffect(() => {
    if (!show) {
      setError("");
      return;
    }
  }, [show]);

  const saveProfile = async () => {};

  const saveEmail = async () => {
    const verificationLink = `${window.location.origin}/?action=verify-email&email=${encodeURIComponent(email)}`;
    console.log("Verification link:", verificationLink);
    return verificationLink;
  };

  const handleSave = async () => {
    const emailChanged = email !== initialValues.email;
    setSaving(true);
    setError("");
    try {
      if (emailChanged) {
        const link = await saveEmail();
        onEmailSaved(EMAIL_SENT_MESSAGE, link);
        onHide();
      } else {
        await saveProfile();
        onSave({ firstName, lastName });
        onHide();
      }
    } catch (err) {
      setError("Failed to save profile. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body className="p-4">
        {error && <Alert variant="danger">{error}</Alert>}
        {loading ? (
          <div className="d-flex justify-content-center py-4">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <Form>
            <Form.Group className="mb-3" controlId="profileFirstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="profileLastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="profileEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={handleEmailChange}
              />
              <Form.Text className="text-danger">
                This email address will be used for password resets
              </Form.Text>
            </Form.Group>
            <Form.Group className="mb-3" controlId="profilePhone">
              <Form.Label>Phone number</Form.Label>
              <Form.Control
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </Form.Group>
          </Form>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button
          variant="dark"
          onClick={handleSave}
          disabled={saving || !isDirty}
        >
          {saving ? "Saving..." : "Save"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default UserProfileModal;
